import { SkeletonRect } from '../SkeletonRect';
import styles from './SkeletonInfrastructure.css';

export const SkeletonInfrastructure = () => {
  return (
    <div className={styles['skeleton-infrastructure']}>
      <SkeletonRect className={styles['map']} borderRadius={8} height="100%" />
      <SkeletonRect height={22} className={styles['distance']} />
      <div className={styles['categories']}>
        <SkeletonRect height={48} className={styles['category']} />
        <SkeletonRect height={48} className={styles['category']} />
        <SkeletonRect height={48} className={styles['category']} />
        <SkeletonRect height={48} className={styles['category']} />
        <SkeletonRect height={48} className={styles['category']} />
      </div>
    </div>
  );
};
